"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagseguro = exports.PagseguroProvider = void 0;
const react_1 = __importStar(require("react"));
const PagSeguroPromiseResolve_1 = __importDefault(require("../pages/paymentBooking/payment/PagSeguro/PagSeguroPromiseResolve"));
const ConfirmValuesContext_1 = require("../pages/paymentBooking/context/ConfirmValuesContext");
const PagseguroContext = (0, react_1.createContext)({});
const PagseguroProvider = ({ children }) => {
    const confirmValuesContext = (0, ConfirmValuesContext_1.useConfirmValues)();
    const [brandState, setBrandState] = (0, react_1.useState)({});
    const [installmentsList, setInstallmentsList] = (0, react_1.useState)({});
    const [selectedInstallment, setSelectedInstallment] = (0, react_1.useState)(null);
    const fetchInstallments = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const { confirmValues } = confirmValuesContext;
        yield PagSeguroPromiseResolve_1.default.myGetInstallments({ amount: confirmValues.totalPrice, brand: brandState === null || brandState === void 0 ? void 0 : brandState.brand })
            .then(response => {
            setInstallmentsList(response);
        })
            .catch(err => {
            throw new Error(`${err}`);
        });
    }), [brandState.brand, confirmValuesContext]);
    const handleSetCvvStateAndInstallments = (0, react_1.useCallback)((cardNumber) => __awaiter(void 0, void 0, void 0, function* () {
        if (cardNumber) {
            yield PagSeguroPromiseResolve_1.default.myGetBrand(Number(cardNumber))
                .then(({ brand }) => {
                setBrandState(old => (Object.assign(Object.assign({}, old), { brand: brand.name })));
            })
                .catch(err => {
                throw new Error(`${err}`);
            });
        }
    }), []);
    const cleanInstallmentsList = (0, react_1.useCallback)(() => {
        setInstallmentsList({});
        setSelectedInstallment(null);
    }, []);
    const cleanBrandState = () => {
        setBrandState({});
    };
    return (react_1.default.createElement(PagseguroContext.Provider, { value: {
            brandState,
            handleSetCvvStateAndInstallments,
            cleanBrandState,
            installmentsList,
            fetchInstallments,
            cleanInstallmentsList,
            selectedInstallment,
            setSelectedInstallment,
        } }, children));
};
exports.PagseguroProvider = PagseguroProvider;
const usePagseguro = () => {
    const context = (0, react_1.useContext)(PagseguroContext);
    return context;
};
exports.usePagseguro = usePagseguro;
